export const getIndices = (state) => state.desempenhoBiodiversidade.indices
export const getIsLoading = (state) => state.desempenhoBiodiversidade.isLoading
export const getAnoCarregado = (state) => state.desempenhoBiodiversidade.anoCarregado
